export const nailTreatments = [
  { name: "Classic Manicure", price: "$25" },
  { name: "Gel Manicure", price: "$40" },
  { name: "Deluxe Manicure", price: "$45" },
  { name: "Collagen Manicure", price: "$55" },
];

export const nailEnhancements = [
  { name: "Acrylic Gel", fullSet: "$55+", fill: "$45+" },
  { name: "Acrylic Pink & White", fullSet: "$70+", fill: "$60+" },
  { name: "Acrylic Ombre", fullSet: "$70+", fill: "$60+" },
  { name: "Liquid / Builder / Hard Gel", fullSet: "$60+", fill: "$50+" },
  { name: "Gel X Full Set", fullSet: "$65+", fill: "$55+" },
  { name: "Tap Gel", fullSet: "$70+", fill: "$60+" },
  { name: "Dipping Powder", fullSet: "$55+", fill: "n/a" },
  { name: "Full Set Toe", fullSet: "$50+", fill: "n/a" },
];

export const waxing = [
  { name: "Eyebrows", price: "$15+" },
  { name: "Lips", price: "$10+" },
  { name: "Chin", price: "$15+" },
  { name: "Full Face", price: "$45+" },
  { name: "Side Burns", price: "$15+" },
  { name: "Under Arm", price: "$25+" },
  { name: "Half Arm", price: "$30+" },
  { name: "Full Arm", price: "$45+" },
  { name: "Half Legs", price: "$45+" },
  { name: "Full Legs", price: "$65+" },
  { name: "Bikini", price: "$50+" },
  { name: "Chest", price: "$55+" },
  { name: "Back Half / Full", price: "$65/75+" },
  { name: "Hands & Fingers", price: "$25+" },
  { name: "Brazilian", price: "$80+" },
  { name: "Ears", price: "$20+" },
];

export const addOns = [
  { name: "Nail Repair ea.", price: "$5+" },
  { name: "Removal w/ Service", price: "$10" },
  { name: "Removal w/o Service", price: "$15" },
  { name: "Nail Trimming", price: "$15" },
  { name: "Toe Trimming", price: "$20" },
  { name: "Cuticle Treatment", price: "$10" },
  { name: "Manicure Add-ons", price: "$20" },
  { name: "Reg. Polish Change", price: "$15/$20" },
  { name: "Gel Polish Change", price: "$25/$30" },
  { name: "Gel Add-ons", price: "$15" },
  { name: "Ombre", price: "$15" },
  { name: "Cat Eyes", price: "$15" },
  { name: "Jelly Color", price: "$10" },
  { name: "Chrome", price: "$15" },
  { name: "Matte Top Coat", price: "$5" },
  { name: "Nail Art", price: "$10+" },
  { name: "Shape", price: "$5+" },
  { name: "French", price: "$10" },
  { name: "Deep, U, V French", price: "$15+" },
  { name: "Acrylic Toe Nails ea.", price: "$10" },
];

export const pedicures = [
  {
    name: "Volcano Surge Pedicure",
    tag: "Ultimate Signature Experience",
    price: "$85",
    description:
      "Indulge in the pinnacle of luxury foot care with our Volcano Surge Pedicure, the ultimate spa experience designed to detoxify, renew, and deeply nourish your feet. This premium treatment begins with professional toenail trimming, cuticle grooming, and a refreshing foot scrub to cleanse and prepare your skin. Gentle callus removal eliminates rough, dry areas before an invigorating sugar scrub exfoliates and reveals smoother, softer skin. A detoxifying mud mask replenishes moisture and revitalizes tired feet, while warm towel wraps and a soothing paraffin wax treatment deeply hydrate and lock in lasting softness. Finish your escape with an indulgent 20-minute hot stone massage, where heated stones melt away tension, improve circulation, and provide total relaxation from your feet to your legs. Inspired by professional Volcano Spa treatments that combine exfoliation, detoxification, hydration, and aromatherapy for the ultimate salon experience.",
    includes: [
      "Callus Removal",
      "Exfoliating Sugar Scrub",
      "Detoxifying Mud Mask",
      "Hot Towel Wrap",
      "Paraffin Wax Treatment",
      "20-Minute Hot Stone Massage",
    ],
  },
  {
    name: "Collagen Luxury Pedicure",
    price: "$75",
    description:
      "Experience the ultimate in hydration and rejuvenation with our most luxurious collagen-infused pedicure. Your treatment begins with professional toenail trimming, cuticle grooming, and a refreshing foot scrub to cleanse and smooth the skin. Gentle callus removal and a renewing exfoliating scrub reveal softer, healthier feet, followed by a deeply hydrating mask to restore moisture and revitalize tired skin. Warm towel wraps prepare your feet for a nourishing collagen serum and collagen-infused foot socks that help lock in hydration, improve skin softness, and leave your feet feeling silky smooth. Complete your experience with a soothing 16-minute hot stone massage that relieves muscle tension, promotes circulation, and provides the ultimate spa escape. Inspired by premium collagen spa treatments designed to nourish, hydrate, and restore healthy, radiant-looking skin.",
    includes: [
      "Callus Removal",
      "Renewal Scrub",
      "Hydrating Mask",
      "Hot Towel Wrap",
      "Collagen Serum",
      "Collagen Foot Socks",
      "16-Minute Hot Stone Massage",
    ],
  },
  {
    name: "Bubble Spa Pedicure",
    price: "$65",
    description:
      "Indulge in our most luxurious spa experience, designed to restore, soften, and completely rejuvenate tired feet. Your treatment begins with professional toenail trimming, cuticle grooming, and a refreshing foot scrub to cleanse and smooth the skin. Gentle callus removal and an exfoliating sugar scrub reveal softer, healthier feet, while a detoxifying mud mask deeply nourishes and hydrates. Warm towel wraps and rich paraffin wax lock in moisture, leaving your skin silky smooth. Relax in the soothing glow of a calming candle as a 12-minute hot stone massage melts away stress, eases muscle tension, and improves circulation for the ultimate spa escape. Inspired by premium bubble spa treatments that combine deep hydration, exfoliation, and aromatherapy for exceptionally soft, refreshed feet.",
    includes: [
      "Callus Removal",
      "Exfoliating Sugar Scrub",
      "Detoxifying Mud Mask",
      "Hot Towel Wrap",
      "Paraffin Wax",
      "Relaxing Aromatherapy Candle",
      "12-Minute Hot Stone Massage",
    ],
  },
  {
    name: "Deluxe Pedicure",
    price: "$55",
    description:
      "Treat your feet to the perfect combination of relaxation and intensive care. This luxurious pedicure begins with professional toenail trimming, cuticle grooming, and a refreshing foot scrub to leave your feet clean and polished. Stubborn calluses are gently removed before an exfoliating sugar scrub buffs away dry skin. A nourishing mud mask deeply hydrates and revitalizes tired feet, followed by soothing hot towel wraps to lock in moisture. Finish your experience with a relaxing 10-minute hot stone massage that melts away tension, improves circulation, and leaves your feet feeling soft, smooth, and completely refreshed. Inspired by professional Korean spa treatments that combine exfoliation, hydration, and relaxation for healthier-looking feet.",
    includes: [
      "Callus Removal",
      "Exfoliating Sugar Scrub",
      "Detoxifying Mud Mask",
      "Hot Towel Wrap",
      "10-Minute Hot Stone Massage",
    ],
  },
  {
    name: "Essential Pedicure",
    price: "$35",
    description: "",
    includes: [
      "Toenail Trim & Shape",
      "Cuticle Grooming",
      "Refreshing Foot Scrub",
      "Moisturizing Lotion",
      "Hot Stone Massage",
      "Polish Application",
    ],
  },
];

export const contact = {
  phone: "(623) 925-9008",
  phoneHref: "tel:6239259008",
  website: "www.bqnailsspa.com",
  websiteHref: "https://www.bqnailsspa.com",
  address: "330 N Dysart Rd #107, Goodyear, AZ 85338",
  mapHref: "https://maps.google.com/?q=330+N+Dysart+Rd+%23107+Goodyear+AZ+85338",
};
